const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Google Export Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('GoogleExport', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/google-export/:subresource', null, {
    fileExport: {params: {subresource: 'file'}, method: 'POST', isArray: false},
    videoExport: {params: {subresource: 'video'}, method: 'POST', isArray: false},
  });

}]);
